export enum TableExtraColumn {
    Expand = 'table-extra-col-expand',
    Scrollbar = 'table-extra-col-scrollbar',
    Selection = 'table-extra-col-selection'
}
